<template>
  <section>
    <div class="mui-content pd-8">
      <div class="title-name">
        <span class="">卷详情（经编）</span>
      </div>
      <!--基础信息-->
      <div class="sampling-first" style="border-bottom: 1px dashed #CCCCCC;margin-top:15px;" >
        <!--第一行-->
        <div class="sampling-first-title">
          <h4>基础信息</h4>
        </div>
        <!--第二行内容-->
        <div class="sampling-first-content">
          <!--第2行-->
          <div style="display: flex;padding-top: 0px;padding-bottom: 3px;">
            <div class="flex-1" style="font-size: 13px; display: flex;">
              <div class="sampling-first-content-left" style="flex: 0;text-align: left;min-width: 50px;padding-left: 12px;">
                <span>物料:</span>
              </div>
              <div class="flex-3" style="white-space: nowrap;">
                <span>{{scxtwph}} {{scxtwpmc}}</span>
              </div>
            </div>
            <div class="flex-1" style="font-size: 13px;display: flex;padding-top: 0px;padding-bottom: 3px;">
              <div class="sampling-first-content-left" style="flex: 0;text-align: left;min-width: 75px;padding-left: 12px;">
                <span>已检数量:</span>
              </div>
              <div class="flex-3">
                <span>{{yjsl}}{{dw}}</span>
              </div>
            </div>
          </div>
          <!--第1行-->
          <div style="font-size: 13px;padding-top: 0px;padding-bottom: 3px;">
            <div class="sampling-first-content-left" style="flex: 0;text-align: left;min-width: 75px;padding-left: 12px;">
              <span>外注订单:</span>
            </div>
            <div class="flex-9">
              <span>{{ddh}}</span>
            </div>
          </div>
          <!--第2行-->
          <div style="font-size: 13px;padding-top: 0px;padding-bottom: 3px;">
           <div class="sampling-first-content-left" style="flex: 0;text-align: left;min-width: 75px;padding-left: 12px;">
              <span>订单数量:</span>
            </div>
            <div class="flex-9">
              <span>{{sl}}{{dw}}</span>
            </div>
          </div>
          <!--第3行-->
          <!-- 2025 0A 0002 质检标签添加剩余未打卡量展示 ↓ -->
          <div style="font-size: 14px;padding-top: 0px;padding-bottom: 3px;display: block;" class="hover-container">
            <div style="flex-grow: 1;display:flex">
              <div style="color: #333333;width:110px;"><!-- class="sampling-first-content-left" -->
                <span>订单未打卡数量:</span>
              </div>
              <div style="width:calc(100% - 110px);">
                <span>{{sysl}}{{dw}}</span>
                <span class="mui-icon mui-icon-info hover-trigger" style="font-size:20px;color:#1F6FB5" ></span>
              </div>
            </div>
            <div style="flex-grow: 1;font-size: 14px;padding-top: 0px;padding-bottom: 3px;margin-top:3px;" class="hover-content">
              <div class="hover-reveal" style="width:100%">订单未打卡数量 = 订单量 - TSD实际入库量（包含系统入库和无系统入库） - 生产未出库量 - 在途量</div>
            </div>
          </div>
          <!-- 2025 0A 0002 质检标签添加剩余未打卡量展示 ↑ -->
        </div>
      </div>
      <div class="sampling-first" style="border-bottom: 0px;">
        <div style="padding-top: 10px;position: relative">
          <!--第一行-->
          <div class="form-group">
            <div class="input-label">
              <label>织机机台：</label>
            </div>
            <div class="form-input">
            	<!-- 只读 -->
            	<input type="text" maxlength="10" v-model="machineno" disabled @blur.prevent="toUpperCase('machineno')" v-if="mode!='add'"/>
            	<!-- 只读 -->
            	<!-- 新增 -->
				<div style="width: 85%;margin-bottom: 15px;" v-if="mode=='add'">
              		<multiselect v-model="minfo" :options="machineLst" :close-on-select="true" placeholder="请输入机台号"  label="machineno" track-by="machineno" @select="machineSel" :multiple="false" :showLabels = "false" :allowEmpty="false"></multiselect>
       			</div>
       			<!-- 新增 -->
        	</div>
          </div>
          <div class="form-group">
            <div class="input-label">
              <label>坯布品番：</label>
            </div>
            <div class="form-input">
              <select v-model="clothcodeinfo" v-show="mode=='add'" @change="clothchange">
                <option :value="item" v-for="(item,idx) in clothcodeLst" :key="idx">{{item.pbph}}</option>
              </select>
              <input type="text" v-model="clothcode" disabled v-show="mode!='add'"/>
            </div>
          </div>
          <div class="form-group">
            <div class="input-label">
              <label>外注卷号：</label>
            </div>
            <div class="form-input">
              <input type="text" maxlength="20" v-model="wzrollno" :disabled="mode=='read' || (type=='edit' &&inspectflag=='0')" @blur.prevent="toUpperCase('wzrollno')"/>
            </div>
          </div>
          <div class="form-group">
            <label class="input-label">净重：</label>
            <div class="form-input" style="display: flex;">
              <input type="text" style="flex:11;" maxlength="8" v-model="netweight" :disabled="mode=='read' || (type=='edit' &&inspectflag=='0')" />
              <div class="input-label" style="flex:3;text-align: center;">
                {{dw}}
              </div>
            </div>
          </div>
          <div class="form-group">
            <div class="input-label">
              <label>匹数：</label>
            </div>
            <div class="form-input">
              <input type="text" maxlength="5" v-model="boltnum" :disabled="mode=='read' || (type=='edit' &&inspectflag=='0') || isboltauto =='1'"/>
            </div>
          </div>
          <div class="form-group">
            <label class="input-label">落布日期：</label>
            <div class="form-input" style="display: flex;">
              <input type="text" style="flex: 11;" id="pickDateBtn" :data-options='dataoptions' v-model="fallingtime" :disabled="mode!='add'" @tap="showpicker" />
              <div class="input-label" style="flex:3;"></div>
            </div>
          </div>
          <div class="form-group">
            <div class="input-label">
              <label>挡车记录：</label>
            </div>
            <div class="form-input">
              <textarea rows="" cols="" v-model="dcremark" maxlength="200" :disabled="mode!='add'"></textarea>
            </div>
          </div>
          <div class="form-group">
            <div class="input-label">
              <label>验布记录：</label>
            </div>
            <div class="form-input">
              <textarea rows="" cols="" v-model="checkremark" maxlength="200" :disabled="!(type=='edit' &&inspectflag=='0')"></textarea>
            </div>
          </div>
          <div class="form-group">
            <div class="input-label">
              <label>备注：</label>
            </div>
            <div class="form-input">
              <textarea maxlength="10" v-model="remark" :disabled="mode!='add'"></textarea>
            </div>
          </div>
          <div class="form-group">
            <div class="input-label">
              <label>备注1：</label>
            </div>
            <div class="form-input">
              <textarea maxlength="250" v-model="remark1" :disabled="mode!='add'"></textarea>
            </div>
          </div>
          <div class="form-group">
            <div class="input-label">
              <label>备注2：</label>
            </div>
            <div class="form-input">
              <textarea maxlength="250" v-model="remark2" :disabled="mode!='add'"></textarea>
            </div>
          </div>
          <div class="form-group" v-if="mode!='read'">
            <label class="input-label">标签设备：</label>
            <div class="form-input" style="display: flex;">
              <select v-model="device">
                <option :value="item" v-for="(item,idx) in deviceLst" :key="idx">{{item.f_dvname}}</option>
              </select>
              <span class="input-label" style="flex:3;">
              </span>
            </div>
          </div>
          <div class="form-group" style="width:100%;margin-top: 10px;margin-bottom: 10px;">
            <button type="button" class="mui-btn mui-btn-primary btn-blue" style="margin: auto;width: 80px;" v-if="mode!='read'" @tap="finish">完成</button>
            <button type="button" class="mui-btn mui-btn-default" style="margin: auto;width: 80px;" v-if="mode=='add'" @tap="conadd">继续添加</button>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
import Multiselect from 'vue-multiselect'
import Vue from 'vue'
Vue.component('multiselect', Multiselect)
export default {
  name: "qualityDetailBZJB",
  components: { Multiselect },
  data() {
    return {
      ddh: "",
      wph: "",
      scxtwph: "",
      scxtwpmc: "",
      yjsl: "",
      sl: "",
      dw: "",
      tsdrollno: "",
      machineno: "", // 织机机台
      clothcode: "", // 坯布品番
      clothcodeinfo: null,
      clothcodeLst: [],
      wzrollno: "", // 外注卷号
      old_wzrollno:"", // 编辑模式下 原始外注卷号
      boltnum: "", // 匹数
      old_boltnum:"", // 编辑模式下 原始匹数
      clothremakflg: "", // 坯布区分
      length: "", // 长度
      netweight: "", // 净重
      old_netweight:"", // 编辑模式下 原始净重
      fallingtime: "", // 落布时间
      remark: "", // 备注
      mode: "", // mode add read
      shipmentno: "",
      statusflg: "", // 状态 0：质检登录
      //dataoptions:'{"type":"date"}', // 年视图(年月日)
      dataoptions:'{"type":"datetime"}',// 完整日期视图(年月日时分)
      changeyarnflg: "0", // 0：未换纱 1：换纱
      changeyarn_flg: false,
      clothheadflg: "", // 0：非布头 1：布头
      clothhead_flg: false,
      dcremark: "", // 挡车记录
      checkremark: "", // 验布记录
      bdoresult: "",
      ksbh: "",
      deviceLst: [],
      device: null,
      fname: "",
      zdflg: false,
      breadth: "",// 幅宽
      gauge_length: "",// 规格幅长  
      fkdw: "",// 幅宽单位  
      fcdw: "",// 幅长单位
      bcc: "",// 编成长
      bccdw: "",// 编成长单位
      bzzl: "",// 标准重量  
      pbcf: "",// 坯布成分
      inspectflag: "",// 0：质检 1：不质检
      type: "",
      remark1: "",
      remark2: "",
      dbph: "",// 代表品号
      pbpm: "",// 坯布品名
      machineLst: [],
      minfo: null,
      yarnuseflg:false, // 是否启用换纱标识
      isfirstrollflg:false, // 是否是订单物料机台品番下的第一卷
      isovernum:false, // 是否超过订单设定的匹数的第一卷（订单、物料、机台、品番、同纱线）
      hasYarnHisflg:false, // 是否存在挂换纱履历
      erpcontract:0, // 是否订单来源于ERP 0：否 1：是
      wbzflag: 0, // 是否W编织订单 0:否 1：是
      iserpovernum:false, // 是否超过丸编纱线设定的最大匹数的第一卷（订单、物料、机台、品番、同纱线）
      supplementflg: "0", // 是否是卷补录 "0":非补录 "1":补录
      isboltauto:"0", // 是否匹数自动计算 0:否 1：是
      sysl:""  // 20250811 剩余打卡数量
    }
  },
  watch:{
    machineno:function(val){
      var value = isZMSZ(val);
      var str = (value).toUpperCase();
      str = str.replace(/I/g, '').replace(/O/g, '');
      this.machineno = str;
    },
    wzrollno:function(val){
      var tempval = val.replace(/[^\a-\z\A-\Z0-9\u4E00-\u9FA5\u3040-\u309F\u30A0-\u30FF-\\\/\#\_\ ]/g,'');
      this.wzrollno = (tempval).toUpperCase();
    },
    boltnum:function(val){
      this.boltnum = isfloat(val);
    },
    netweight:function(val){
      this.netweight = isfloat(val);
      // 匹数自动匹配逻辑
      this.getBoltnum();
    }
    // dcremark:function(val){
    //   this.dcremark = isText(val);
    // },
    // checkremark:function(val){
    //   this.checkremark = isText(val);
    // }
  },
  created() {},
  activated() {
    var v = this;
    const para = v.$route.params; //getJsonPara(v.$route);
    if (para && para.ddh) {
      v.ddh = para.ddh;
      v.wph = para.wph;
      v.ksbh = para.ksbh;
      v.type = para.type?para.type:"";
      // 是否是卷的补录
      if(para.supplementflg){
        v.supplementflg = para.supplementflg;
      }
      // 抽检
      if (para.shipmentno) {
        v.shipmentno = para.shipmentno;
        v.mode = "read";
      } else {
        v.shipmentno = "";
      }
      // 模式 新增、编辑
      if (para.tsdrollno) {
        v.tsdrollno = para.tsdrollno;
        v.mode = "read";
      } else {
        v.mode = "add";
        v.tsdrollno = "";
      }
      v.getJDetail();
    }
  },
  methods: {
  	machineSel(selectedOption,id){
  		var v = this;
  		v.machineno = selectedOption.machineno;
      v.getMachineYarn();
    },
    getMachineYarn(){
      var v = this;
      if(v.mode!='add') return;
      // 根据选择的机台判断是否开启挂纱操作
      v.getMachineInfo(function(res){
      });
    },
    toFixed(num, s) {
      var times = Math.pow(10, s)
      var des = num * times + 0.5
      des = parseInt(des, 10) / times
      return des + ''
    },
    // 返回一个字符串，该字符串中的所有字母都被转化为大写字母
    toUpperCase(name){
      var v = this;
      if(name == 'machineno'){
        v.machineno = (v.machineno).toUpperCase();
      }else if(name == 'wzrollno'){
        v.wzrollno = (v.wzrollno).toUpperCase();
      }
    },
    setinfo(){
      var v = this;
      v.breadth = v.clothcodeinfo?v.clothcodeinfo.gcfk:"";// 幅宽
      v.gauge_length = v.clothcodeinfo?v.clothcodeinfo.gcfc:"";// 规格幅长  公称幅长
      v.fkdw = v.clothcodeinfo?v.clothcodeinfo.fkdw:"";// 幅宽单位  
      v.fcdw = v.clothcodeinfo?v.clothcodeinfo.fcdw:"";// 幅长单位
      v.bcc = v.clothcodeinfo?v.clothcodeinfo.bcc:"";// 编成长
      v.bccdw = v.clothcodeinfo?v.clothcodeinfo.bccdw:"";// 编成长单位
      v.bzzl = v.clothcodeinfo?v.clothcodeinfo.bzzl:"";// 标准重量  
      v.pbcf = v.clothcodeinfo?v.clothcodeinfo.pbcf:"";// 坯布成分  
      v.dbph = v.clothcodeinfo?v.clothcodeinfo.dbph:"";// 代表品号
      v.pbpm = v.clothcodeinfo?v.clothcodeinfo.pbpm:"";// 坯布品名
    },
    getpbph() {
      var v = this;
      for (var i = 0; i < v.clothcodeLst.length; i++) {
        if (v.clothcode == v.clothcodeLst[i].pbph) {
          v.clothcodeinfo = v.clothcodeLst[i];
          return;
        }
      }
    },
    getJDetail() {
      var v = this;
      v.nyy.doPost("/Quality/getJDetail", {
          ddh: v.ddh,
          wph: v.wph,
          tsdrollno: v.tsdrollno,
          supplementflg: v.supplementflg
        },
        function(result) {
          if (result.status) {
            var info = result.data.info;
            v.scxtwph = info.scxtwph;
            v.scxtwpmc = info.scxtwpmc;
            v.sl = info.sl;
            v.dw = info.dw;
            v.yjsl = info.yjsl;
            v.fname = info.fname;
            v.inspectflag = info.inspectflag;
            // 20211112 追加
            v.erpcontract = info.erpcontract;
            v.wbzflag = info.wbzflag;
            // 坯布品番
            v.clothcodeLst = result.data.pbphInfoList;
            //v.clothcodeLst = [{"pbph":"WZ3450","gcfc":50.0,"bzzl":6.23,"fcdw":"M","pbcf":"PE100","gcfk":148.0,"fkdw":"C","bcc":1.0,"bccdw":"M","dbph":"WZ1230","pbpm":"国内丸编"},{"pbph":"WZ3450-1","gcfc":50.0,"bzzl":0.01,"fcdw":"M","pbcf":"PE100","gcfk":148.0,"fkdw":"C","bcc":1.0,"bccdw":"M","dbph":"WZ1230","pbpm":"国内丸编"}];//result.data.pbphInfoList;

            v.deviceLst = result.data.deviceLst;
            v.device = (v.deviceLst && v.deviceLst.length>0)?v.deviceLst[0]:null;
            v.isboltauto = info.isboltauto || "0";

             // 20250811 剩余未打卡数量 ↓
            // v.sysl = info.sysl;
            // 20250811 剩余未打卡数量 ↑

            if (v.mode == "add") {
              v.machineno = ""; // 织机机台
              v.clothcode = ""; // 坯布品番
              v.gauge_length = "";
              v.clothcodeinfo = (v.clothcodeLst && v.clothcodeLst.length>0)?v.clothcodeLst[0]:null;
              if(v.clothcodeinfo){
                v.clothcode = v.clothcodeinfo.pbph;
              }
              v.init();
              v.zdflg = false;
              v.machineLst = result.data.machineLst;
              //v.getMachineYarn();
            } else {
              v.machineno = info.machineno; // 织机机台
              v.clothcode = info.clothcode; // 坯布品番
              v.getpbph();
              v.wzrollno = info.wzrollno; // 外注卷号
              v.old_wzrollno = info.wzrollno; // 编辑模式下 原始外注卷号 20200221
              v.boltnum = info.boltnum; // 匹数
              v.old_boltnum = info.boltnum; // 编辑模式下 原始匹数
              v.clothremakflg = info.clothremakflg; // 坯布区分
              v.length = info.length; // 长度
              v.netweight = info.netweight; // 净重
              v.old_netweight = info.netweight; // 编辑模式下 原始净重 
              v.fallingtime = info.fallingtime; // 落布时间
              v.remark = info.remark; // 备注
              v.remark1 = info.remark1;// 备注1
              v.remark2 = info.remark2;// 备注2
              v.statusflg = info.statusflg;
              v.supplementflg = info.supplementflg; // 是否补录卷
              // 0:质检登录
              if (v.statusflg == '0') {
                v.mode = "edit";
              } else {
                v.mode = "read";
              }
              v.bdoresult = info.bdoresult;

              v.dcremark = info.dcremark; // 挡车记录
              v.checkremark = info.checkremark; // 验布记录
              v.changeyarnflg = info.changeyarnflg; // 0：未换纱 1：换纱
              v.changeyarn_flg = (info.changeyarnflg == '1' ? true : false);
              v.clothheadflg = info.clothheadflg; // 0：非布头 1：布头
              v.clothhead_flg = (info.clothheadflg == '1' ? true : false);

              v.zdflg = info.zdflg;// 是否已被指定
              if(v.zdflg){
                v.mode = "read";
              }
              // 20250811 剩余未打卡数量 ↓
              v.getContractSYAmount();
              // 20250811 剩余未打卡数量 ↑
            }
            v.setinfo();
          }
        }
      );
    },
    init() {
      var v = this;
      v.wzrollno = ""; // 外注卷号
      v.boltnum = ""; // 匹数
      v.clothremakflg = ""; // 坯布区分
      v.length = ""; // 长度
      v.netweight = ""; // 净重

      v.dcremark = ""; // 挡车记录
      v.checkremark = ""; // 验布记录
      v.changeyarnflg = "0"; // 0：未换纱 1：换纱
      v.changeyarn_flg = false;
      v.clothheadflg = "0"; // 0：非布头 1：布头
      v.clothhead_flg = false;

      var date = new Date(); //获取当前时间
      var now_date = v.getFormatDate(date) + " " + v.GetDefalutTime();
      v.fallingtime = now_date; // 落布时间

      v.remark = ""; // 备注
      v.remark1 = "";// 备注1
      v.remark2 = "";// 备注2
      v.statusflg = "";
      // 20250811 剩余未打卡数量 ↓
      v.getContractSYAmount();
      // 20250811 剩余未打卡数量 ↑
    },
    showpicker() {
      var v = this;
      var dDate = new Date();
      var optionsJson = v.dataoptions;
      var options = JSON.parse(optionsJson);
      var picker = new mui.DtPicker(options);
      picker.show(function(rs) {
        console.log(rs)
        var timestr = rs.text;
        v.fallingtime = timestr.replace(/-/g, "/");
        picker.dispose();
        if(v.mode!='add') return;
      });
    },
     GetDefalutTime(){
      // 获取系统时间
      var systemDate = new Date();
      var sysTime = "";
      if (systemDate.getHours() < 10) {
          sysTime += "0" + systemDate.getHours();
      } else {
          sysTime += systemDate.getHours();
      }
      if (systemDate.getMinutes() < 10) {
          sysTime += ":0" + systemDate.getMinutes();
      } else {
          sysTime += ":" + systemDate.getMinutes();
      }
      return sysTime;
    },
    getFormatDate(date) {
      var seperator1 = "/";
      var year = date.getFullYear();
      var month = date.getMonth() + 1;
      var strDate = date.getDate();
      if (month >= 1 && month <= 9) {
        month = "0" + month;
      }
      if (strDate >= 0 && strDate <= 9) {
        strDate = "0" + strDate;
      }
      var currentdate = year + seperator1 + month + seperator1 + strDate;
      return currentdate;
    },
    // 完成
    finish() {
      var v = this;
      if (!v.check()) return;
      // 校验标签设备是否选择
      if (!v.device && (v.type != 'edit')) {
        mui.toast("请选择标签设备");
        return;
      }
      if(v.mode=='add'){
        // 校验同纱匹数
        v.checkSNum(function(){
            var postMap = v.setMap();
            postMap.labelprinttime = "";
            v.addJ(postMap, function() {
              v.printZJBQ();
            });
        });
      }else{
          // 质检
          if(v.mode == "edit" || (v.inspectflag=='0' && v.type == "edit")){ // 20200221 追加 编辑模式可修改信息
            v.updateJ(function(){
              if(v.inspectflag=='0' && v.type == "edit"){ // 验布记录的模式下
                v.$router.go(-1);
              }else{
                // 判断修改前的值和修改后的是否有变化，如有，则重打标签
                //if((v.old_wzrollno != v.wzrollno) || (v.old_boltnum != v.boltnum) || (v.old_netweight != v.netweight)){
                  
                  v.printZJBQ();
                //}else{
                  //v.$router.go(-1);
                //}
              }
            },"");
          }else{
            v.printZJBQ();
          }
      }
    },
    checkSNum(callback){
      var v = this;
      if(callback) callback();
    },
    // 打印质检标签
    printZJBQ(callback) {
      var v = this;
      var bcc = ((v.bcc == "")?"0":v.bcc);
      var length = (parseFloat(v.boltnum) * parseFloat(bcc)).toFixed(1);
      // 针织布的规格：幅宽+幅宽单位 * 幅长+幅长单位 (编成长 + 编成长单位)
      var postMap = {
        "tsdrollno": v.tsdrollno, // TSD卷号
        "clothcode": v.clothcode, // 坯布品番 (坯布质检 - 坯布品番 )
        "breadth": v.breadth, // ERP-幅宽（单位CM）
        "gauge_length": v.gauge_length, // ERP-公称幅长（单位M）
        "length": length, // 布  长
        "boltnum": v.boltnum, // 匹数
        "netweight": v.netweight, // 重    量
        "bdoresult": v.bdoresult, // 色 区 分 (悬念反处置结果 关联取样单号可以获取;若没有，固定值“无”)
        "fname": v.fname, // 织布工厂 (供应商-简称 表中数据对应简称2)
        "wzrollno": v.wzrollno, // 外注卷号
        "fallingtime": v.fallingtime, // 落布时间(yyyy年mm月dd日)
        "clothremakflg": "", // 坯布区分 机织的情况下使用
        "remark": v.remark, // 备    注
        "ddqf": "2", // 订单区分
        "dvno": v.device.dvno, // 终端编号
        "fkdw": v.fkdw,// 幅宽单位
        "fcdw": v.fcdw,// 幅长单位
        "bcc": v.bcc,// 幅成长
        "bccdw": v.bccdw// 幅成长单位
      };
      v.nyy.doPost("/Quality/printZJBQ", postMap,
        function(result) {
          if (result.status) {
            if(callback){
              callback();
            }else{
              v.$router.go(-1);
            }
          }
        }
      );
    },
    check() {
      var v = this;
      if (v.machineno == "") {
        mui.toast("请输入织机机台");
        return false;
      }
      if (v.clothcodeinfo == "") {
        mui.toast("请选择坯布品番");
        return false;
      }
      v.clothcode = v.clothcodeinfo.pbph;
      v.setinfo();
      if (v.wzrollno == "") {
        mui.toast("请输入外注卷号");
        return false;
      }
      //if((v.wzrollno).indexOf(v.machineno)<=-1){
      if(!v.wzrollno.startsWith(v.machineno)){
        mui.toast("请确认外注卷号和机台是否匹配");
        return false;
      }
      // 根据 录入的净重/标准重量 来校验匹数输入的范围是否正确
      if (v.boltnum == "") {
        mui.toast("请输入匹数");
        return false;
      }
      if(parseInt(v.boltnum)>999){
        mui.toast("请输入合法匹数");
        return false;
      }
      if (!v.isSZO(v.boltnum)) {
        mui.toast("请输入只含一位小数的匹数");
        return false;
      }
      // 根据 录入的净重/标准重量 来校验匹数输入的范围是否正确 todo
      if (v.netweight == "") {
        mui.toast("请输入净重");
        return false;
      }
      if (!is8SZ(v.netweight)) {
        mui.toast("请输入合法净重");
        return false;
      }
      if(parseInt(v.netweight)>999){
        mui.toast("请输入合法净重");
        return false;
      }
      if(v.boltnum<=0){
        mui.toast("请输入合法匹数");
        return false;
      }
      // 判断布匹数输入是否是0.5的倍数
      if(!v.checkZeroFive(v.boltnum)){
        mui.toast("请输入匹数正确的小数位的值");
        return false;
      }
      if(v.bzzl && (parseFloat(v.bzzl)>0)){
        // 若未启用匹数自动计算，则按照原规则校验
        if(v.isboltauto != "1"){
          /*// 匹数 称重重量/标准重量 ±1
          // 对数进行上舍入
          var ps_max = Math.ceil(parseFloat(v.netweight)/parseFloat(v.bzzl));
          // 对数进行下舍入
          var ps_min = Math.floor(parseFloat(v.netweight)/parseFloat(v.bzzl));
          if((parseFloat(v.boltnum) > ps_max) || (parseFloat(v.boltnum) < ps_min)){
            mui.toast("根据标准重量和输入的净重，匹数可输入区间为(" + ps_min + "," + ps_max + ")");
            return false;
          }*/
          // 匹数 称重重量/标准重量 上下浮动30% 20190524  吴给出的范围
          // 匹数规则 实际重量除以标准重量后直接+_0.3 2020/01/08 吴给出的范围 
          var ps_temp = (parseFloat(v.netweight)/parseFloat(v.bzzl)).toFixed(2);
          // var ps_max = v.toFixed((parseFloat(ps_temp) * (1 + 0.3)),1);
          // var ps_min = v.toFixed((parseFloat(ps_temp) * (1 - 0.3)),1);
          var ps_max = v.toFixed((parseFloat(ps_temp) + 0.3),1);
          var ps_min = v.toFixed((parseFloat(ps_temp) - 0.3),1);

          if((parseFloat(v.boltnum) > parseFloat(ps_max)) || (parseFloat(v.boltnum) < parseFloat(ps_min))){
            mui.toast("根据标准重量和输入的净重，匹数可输入区间为(" + ps_min + "," + ps_max + ")");
            return false;
          }
        }
      }
      if (v.fallingtime == "") {
        mui.toast("请输入落布时间");
        return false;
      }
      if (v.dcremark == "") {
        mui.toast("请输入挡车记录");
        return false;
      }
      // 是否自主质检
      if (v.inspectflag == "0" && v.type=="edit") {
        if (v.checkremark == "") {
          mui.toast("请输入验布记录");
          return false;
        }
      }
      return true;
    },
    setMap() {
      var v = this;
      // 米数计算（编成长*匹数）
      var bcc = ((v.bcc == "")?"0":v.bcc);
      var length = (parseFloat(v.boltnum) * parseFloat(bcc)).toFixed(1);
      var postMap = {
        "ddh": v.ddh,
        "wph": v.wph,
        "wzrollno": (v.wzrollno).toUpperCase(), // 外注卷号
        "machineno": (v.machineno).toUpperCase(), // 织机机台
        "clothcode": v.clothcode, // 坯布品番
        "boltnum": v.boltnum, // 匹数
        "length": length, // 长度
        "netweight": v.netweight, // 净重
        "fallingtime": v.fallingtime, // 落布时间
        "remark": v.remark, // 备注
        "statusflg": "0",
        "ddqf": "2",
        "dcremark": v.dcremark, // 挡车记录
        "checkremark": v.checkremark, // 验布记录
        "changeyarnflg": (v.changeyarn_flg ? "1" : "0"), // 0：未换纱 1：换纱
        "clothheadflg": (v.clothhead_flg ? "1" : "0"), // 0：非布头 1：布头
        "ksbh": v.ksbh,
        "remark1": v.remark1,// 备注1
        "remark2": v.remark2,// 备注2
        "supplementflg": v.supplementflg // 是否补录
      };
      return postMap;
    },
    addJ(postMap, callback) {
      var v = this;
      v.Noclothhead_confirm(function(){
        // 新增字段
        postMap.breadth = v.breadth;// 幅宽
        postMap.gauge_length = v.gauge_length;// 规格幅长  
        postMap.fkdw = v.fkdw;// 幅宽单位  
        postMap.fcdw = v.fcdw;// 幅长单位
        postMap.bcc = v.bcc;// 编成长
        postMap.bccdw = v.bccdw;// 编成长单位
        postMap.bzzl = v.bzzl;// 标准重量
        postMap.pbcf = v.pbcf;// 坯布成分 
        postMap.dbph = v.dbph;// 代表品号
        postMap.pbpm = v.pbpm;// 坯布品名

        v.nyy.doPost("/Quality/addJ", postMap,
          function(result) {
            if (result.status) {
              v.tsdrollno = result.data.tsdrollno;
              if (callback) callback();
            } else {
                mui.toast(result.message);
            }
          }
        );
      });
    },
    // 继续添加
    conadd() {
      var v = this;
      if (!v.check()) return;
      // 校验同纱匹数
      v.checkSNum(function(){
        if (!v.device) {
            mui.toast("请选择标签设备");
            return;
        }
        var postMap = v.setMap();
        v.addJ(postMap, function() {
          v.printZJBQ(function(){
            v.init();
          });
        });
      });
    },
    Noclothhead_confirm(callback){
      var v = this;
      if(!v.clothhead_flg){
        mui.confirm('是否确认保存？', '提示', ['否', '是'], function(e) {
          if (e.index == 1) {
            if(callback)callback();
          }
        });
      }else{
        if(callback)callback();
      }
    },
    hz_confirm(msg,callback){
      var v = this;
      mui.confirm(msg, '提示', ['暂不处理', '去换纱'], function(e) {
        if (e.index == 1) {
          if(callback)callback();
        }
      });
    },
    updateJ(callback,erpflag){
      var v = this;
      // 米数计算（编成长*匹数）
      var bcc = ((v.bcc == "")?"0":v.bcc);
      var length = (parseFloat(v.boltnum) * parseFloat(bcc)).toFixed(1);
      // 可修改验布记录
      var postMap = {
        "ddh": v.ddh,
        "wph": v.wph,
        "tsdrollno": v.tsdrollno,
        "checkremark": v.checkremark,
        "wzrollno": (v.wzrollno).toUpperCase(), // 外注卷号可编辑 2020/1/7 课题95
        "boltnum": v.boltnum, // 匹数 可编辑 2020/1/7 课题95
        "netweight": v.netweight, // 净重 可编辑 2020/1/7 课题95
        "length" : length, // 匹数变更时，长度对应变更 2020/4/24 课题95
        "machineno": (v.machineno).toUpperCase(), // 织机机台
        "clothcode":v.clothcode, // 坯布品番
        "fallingtime": v.fallingtime, // 落布时间
        "remark": v.remark, // 备注
        "dcremark": v.dcremark // 挡车记录
      };
      if(erpflag){
        postMap.erpflag = erpflag;
      }
      v.nyy.doPost("/Quality/updateJ", postMap,
        function(result) {
          if (result.status) {
            if (callback) callback();
          } else {
            mui.toast(result.message);
          }
        }
      );
    },
    // 正实数，整数位最多3位，最多1位小数
    isSZO(str) {
      var reg = /^\d{1,3}$|^\d{1,3}[.]\d{1,1}$/;
      if (!reg.test(str)) {
          return false;
      }
      return true;
    },
    // 判断是否是0.5的整倍数
    checkZeroFive(str){
      var num = parseFloat(str) * 10;
      var num_qy = num % 5;
      if(num % 5 == 0){
        return true;
      }
      return false;
    },
    getMachineInfo(callback){
      var v = this;
      // 获取机台信息(是否启用挂纱)
      var postMap = {
        "machineno": v.machineno,
        "ddh":v.ddh,
        "wph":v.wph
      };
      v.nyy.doPost("/Quality/getMachineInfo", postMap,
        function(result) {
          if (result.status) {
            if (callback) callback(result.data);
          } else {
            mui.toast(result.message);
          }
        }
      );
    },
    clothchange(){
      var v = this;
      v.clothcode = v.clothcodeinfo.pbph;
      if(v.mode!='add') return;
      // 设置编程长相关
      v.setinfo();
      // 自动计算匹数
      v.getBoltnum();
    },
    getBoltnum(){
      const v = this;
      // 若是未启用经编匹数自动计算，则直接返回
      if(v.isboltauto != '1'){ 
        return;
      }
      // 标准重量 v.bzzl
      // 重量 v.netweight
      if(v.checkKey(v.netweight) || v.checkKey(v.bzzl)){
        v.boltnum = "";
        return;
      }

      if(v.bzzl === 0){
        v.boltnum = "";
        return;
      }

      // 计算规则：
      // 标准匹重*0.6~0.8=0.5P，
      // 标准匹重*0.81~1.3=1P，
      // 标准匹重*1.31~1.8=1.5P，
      // 标准匹重*1.81~2.3=2P,以此类推
      // 每个品号都有标准的匹重，拿目前劲派做的6361来举例子：6361的标准匹重是14.4KG/P，如果现在落布称重是50KG，那么50/14.4=3.47，区间适用于3.31~3.8之间，劲派入库就按照3.5P入库

      const ratio = v.netweight / this.bzzl;
      // 落布称重在标准匹重*0.6~0.8=0.5P，
      if(ratio >= 0.6 && ratio <= 0.8){
        v.boltnum = 0.5;
      }else if(ratio > 0.8){
        // 对于大于0.8的情况，使用通用公式计算
        let base = 0.8;
        let stepSize = 0.5;
        let normalized = ratio - base;
        let step = normalized / stepSize;
        
        if(v.isExactlyDivisible(normalized, stepSize)){
           v.boltnum = 1 + (Math.floor(step) - 1) * 0.5;
        }else{
           v.boltnum = 1 + Math.floor(step) * 0.5;
        }
      }else{
        // 小于0.6的情况
        v.boltnum = 0;
      }
    },
    checkKey(val){
      return val === null || val === "" || val === undefined;
    },
    isExactlyDivisible(dividend, divisor) {
      // 使用Number.EPSILON解决浮点数精度问题
      const remainder = dividend % divisor;
      return Math.abs(remainder) < Number.EPSILON || 
          Math.abs(remainder - divisor) < Number.EPSILON;
    },
    // 获取订单剩余数量
    getContractSYAmount(callback) {
      var v = this;
      v.nyy.doPost("/Quality/getContractSYAmount", {
        ddh: v.ddh,
        wph: v.wph
      },
      function(result) {
        if (result.status) {
          // 20250811 剩余未打卡数量 ↓
          v.sysl = result.data.info.sysl;
          // 20250811 剩余未打卡数量 ↑
          if (callback) callback();
        } else {
          mui.toast(result.message);
        }
      }
      );
    }
  }
}
</script>
<style scoped>
@import "../../static/css/sampling.css";
@import "../../static/css/samplinghistory.css";
@import "../../static/css/filterorder.css";
@import "../../static/css/quality.css";
</style>



// WEBPACK FOOTER //
// src/components/qualityDetailBZJB.vue